import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import monitorApi from "./api/monitorApi";
import { AppContentPropsType } from "./AppTypes";
import { AuthProtectedRoute } from "./AuthProtectedRoute";
import MobileMenu from "./components/MobileMenu/MobileMenu";
import AboutPage from "./pages/AboutPage/AboutPage";
import ChoosePage from "./pages/ChoosePage/ChoosePage";
import ContactsPage from "./pages/ContactsPage/ContactsPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import MainPage from "./pages/MainPage/MainPage";
import MonitoringPage from "./pages/MonitoringPage/MonitoringPage";
import ShutdownAddPage from "./pages/ShutdownAddPage/ShutdownAddPage";
import ShutdownAddXlsxPage from "./pages/ShutdownAddXlsxPage/ShutdownAddXlsxPage";
import ShutdownDownloadXlsxPage from "./pages/ShutdownDownloadXlsxPage/ShutdownDownloadXlsxPage";
import ShutdownPublishPage from "./pages/ShutdownPublishPage/ShutdownPublishPage";
import StatPage from "./pages/StatPage/StatPage";
import ThankYouPage from "./pages/ThankYouPage/ThankYouPage";
import UploadDnsCsvPage from "./pages/UploadDnsCsvPage/UploadDnsCsvPage";
import UserReportPage from "./pages/UserReportPage/UserReportPage";
import WhiteListCheckerPage from "./pages/WhiteListCheckerPage/WhiteListCheckerPage";
import WhiteListUploadTokensPage from "./pages/WhiteListUploadTokensPage/WhiteListUploadTokensPage";
import { SiteDataProvider } from "./SiteDataContext";
import { SiteDataType } from "./SiteDataTypes";

const AppContent: React.FC<AppContentPropsType> = () => {
  return (
    <Router>
      <MobileMenu />
      <Routes>
        <Route path="/login9M3F5F" element={<LoginPage />} />
        <Route path="/" element={<MainPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/dns-monitor" element={<MonitoringPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="/user-report/:type" element={<UserReportPage />} />
        <Route path="/choose" element={<ChoosePage />} />
        <Route path="/thank-you/:reportId" element={<ThankYouPage />} />
        <Route path="/stat" element={<StatPage />} />

        <Route
          path="/shutdown_publish"
          element={
            <AuthProtectedRoute>
              <ShutdownPublishPage />
            </AuthProtectedRoute>
          }
        />

        <Route
          path="/shutdown_add"
          element={
            <AuthProtectedRoute>
              <ShutdownAddPage />
            </AuthProtectedRoute>
          }
        />
        <Route
          path="/shutdown_add_xlsx"
          element={
            <AuthProtectedRoute>
              <ShutdownAddXlsxPage />
            </AuthProtectedRoute>
          }
        />
        <Route
          path="/shutdown_download_xlsx"
          element={
            <AuthProtectedRoute>
              <ShutdownDownloadXlsxPage />
            </AuthProtectedRoute>
          }
        />
        <Route path="/upload_domain_dns_check" element={<UploadDnsCsvPage />} />
        <Route
          path="/white_list_checker"
          element={
            <AuthProtectedRoute>
              <WhiteListCheckerPage />
            </AuthProtectedRoute>
          }
        />
        <Route
          path="/white_list_checker_upload_tokens"
          element={
            <AuthProtectedRoute>
              <WhiteListUploadTokensPage />
            </AuthProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

const App: React.FC = () => {
  const [siteData, setSiteData] = useState<SiteDataType>({});

  useEffect(() => {
    Promise.all([
      monitorApi.getSiteTexts(),
      monitorApi.getConfig().catch(() => ({
        data: { show_statistics: false, show_dns_monitor: false },
      })),
    ])
      .then(([siteTextsRes, configRes]) => {
        setSiteData({
          ...siteTextsRes.data,
          show_statistics: !!configRes.data.show_statistics,
          show_dns_monitor: !!configRes.data.show_dns_monitor,
        });
      })
      .catch((error) => {
        console.info("There was an error fetching the data!", error);
      });
  }, []);

  return (
    <SiteDataProvider siteData={siteData} setSiteData={setSiteData}>
      <AppContent siteData={siteData} setSiteData={setSiteData} />
    </SiteDataProvider>
  );
};

export default App;
